import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-logas-box',
    templateUrl: './log-as-box.component.html',
    styleUrls: ['./log-as-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/** DEPRECATED */
export class LogAsBoxComponent implements OnInit {
    public ValidEmail = new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(`^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]{2,3}$`)]));
    Model: string;

    constructor(
        public dialogRef: MatDialogRef<LogAsBoxComponent>,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data) {

    }

    ngOnInit(): void {
        this.ValidEmail.markAsPending();

    }

    CanSave() {
        return this.Model;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }
}
